import { createContext, PropsWithChildren, useState } from "react";

export type ModuleRatingTableFilters = {
	from?: number;
	to?: number;
};
type IModuleRatingsContext = {
	state: ModuleRatingTableFilters;
	setState: React.Dispatch<React.SetStateAction<ModuleRatingTableFilters>>;
};
export const ModuleRatingsContext = createContext<IModuleRatingsContext>({
	state: {},
	setState: () => {},
});

export const ModuleRatingsContextProvider = ({ children }: PropsWithChildren<any>) => {
	const [state, setState] = useState<ModuleRatingTableFilters>({
		from: undefined,
		to: undefined,
	});
	return (
		<ModuleRatingsContext.Provider
			value={{
				state,
				setState,
			}}
		>
			{children}
		</ModuleRatingsContext.Provider>
	);
};
